export default __webpack_public_path__ + "static/media/docker.2531de29.svg";